import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

// STORE_OVERRIDES — hand-curated values that ALWAYS win, even over Square.
// Use these to correct fields Square doesn't expose (TikTok) or to display
// preferred values before/instead of what's in the Square location.
const STORE_OVERRIDES = {
  name: "The Dugout",
  phone: "(307) 389-8671",
  email: "Thedugoutrs@gmail.com",
  hours: "Mon–Thu 12–8pm · Fri–Sat 12–10pm · Sun 12–5pm",
  facebook_url: "https://www.facebook.com/DugoutCollectibles",
  instagram_url: "https://instagram.com/at.thedugout",
  instagram_username: "at.thedugout",
  tiktok_url: "https://tiktok.com/@at.thedugout",
  tiktok_username: "at.thedugout",
};

// Base defaults for any field neither Square nor overrides provide.
const STORE_DEFAULTS = {
  name: "Elevation Gaming Co.",
  address_line1: "515 North Front Street",
  city: "Rock Springs",
  state: "WY",
  postal_code: "82901",
  address_full: "515 North Front Street, Rock Springs, WY 82901",
  phone: "",
  email: "",
  hours: "",
  website: "",
  facebook_url: "",
  instagram_url: "",
  instagram_username: "",
  twitter_url: "",
  twitter_username: "",
  tiktok_url: "",
  tiktok_username: "",
  source: "fallback",
};

// Merge helper: keep values that are non-empty strings only.
const merge = (...layers) => {
  const out = {};
  for (const layer of layers) {
    for (const [k, v] of Object.entries(layer || {})) {
      if (v !== null && v !== undefined && v !== "") out[k] = v;
    }
  }
  return out;
};

export const STORE_FALLBACK = merge(STORE_DEFAULTS, STORE_OVERRIDES);

const StoreInfoContext = createContext(STORE_FALLBACK);

export function StoreInfoProvider({ children }) {
  const [info, setInfo] = useState(STORE_FALLBACK);

  useEffect(() => {
    let alive = true;
    api
      .get("/store/info")
      .then((r) => {
        if (!alive) return;
        // Order matters: defaults → Square live data → curated overrides win last.
        setInfo(merge(STORE_DEFAULTS, r.data || {}, STORE_OVERRIDES));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return <StoreInfoContext.Provider value={info}>{children}</StoreInfoContext.Provider>;
}

export const useStoreInfo = () => useContext(StoreInfoContext);
